module.exports = __webpack_public_path__ + "img/mail.efcb4bb6.svg";